import React from "react";
import PropTypes from "prop-types";
import { FileXCorner, Plus } from "lucide-react";

import { UIEmptyState } from "../../../ui";

import "./ReportsShared.scss";

const ReportsEmptyState = ({
  title,
  description,
  actionLabel,
  onAction,
  showAction,
}) => (
  <UIEmptyState
    classNames={{ root: "reports-empty" }}
    title={title}
    description={description}
    icon={<FileXCorner size={40} strokeWidth={2.5} aria-hidden />}
    actionLabel={showAction ? actionLabel : undefined}
    actionIcon={showAction ? <Plus aria-hidden /> : undefined}
    onAction={showAction ? onAction : undefined}
  />
);

ReportsEmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  actionLabel: PropTypes.node,
  onAction: PropTypes.func,
  showAction: PropTypes.bool,
};

ReportsEmptyState.defaultProps = {
  description: null,
  actionLabel: null,
  onAction: undefined,
  showAction: true,
};

export default ReportsEmptyState;
